import type { CmsApiSubscribe } from '#/modules/cms/api/types/CmsApiSubscribe';
import type { ApiSavedSearchUnsaved } from '#/modules/userDashboard/api/savedSearch/types/UserDashboardApiSavedSearch';

import type { AuthApiTmpStorage } from './types/AuthApiTmpStorage';

type SignupBlockRedirect = {
  redirectUrl: string;
};

type SaveListingType = {
  id: string;
  type: string;
};

type SubscribeSubsiteType = {
  subscribedSubsiteId: string;
};

type SaveSearchAction = {
  type: 'SAVE_SEARCH';
  data: ApiSavedSearchUnsaved;
};

type CmsSubscribeAction = {
  type: 'CMS_SUBSCRIBE';
  data: CmsApiSubscribe;
};

type SignupBlockRedirectAction = {
  type: 'SIGNUP_BLOCK_REDIRECT';
  data: SignupBlockRedirect;
};

type SaveListingAction = {
  type: 'SAVE_LISTING';
  data: SaveListingType;
};

type SusbscribeSubsiteAction = {
  type: 'SUBSCRIBE_SUBSITE';
  data: SubscribeSubsiteType;
};

type AuthApiOldActionAction =
  | SaveSearchAction
  | CmsSubscribeAction
  | SignupBlockRedirectAction
  | SaveListingAction
  | SusbscribeSubsiteAction;

export function authApiConvertTmpStorageOldActions(
  action: AuthApiOldActionAction,
): AuthApiTmpStorage | null {
  switch (action.type) {
    case 'SAVE_SEARCH':
      return { type: 'savedSearch', savedSearch: action.data };

    case 'CMS_SUBSCRIBE':
      return { type: 'cmsSubscribe', cmsSubscribe: action.data };

    case 'SIGNUP_BLOCK_REDIRECT':
      return { type: 'redirect', redirectUrl: action.data.redirectUrl };

    case 'SAVE_LISTING':
      return { type: 'savedListing', savedListing: action.data };

    case 'SUBSCRIBE_SUBSITE':
      return {
        type: 'subscribedSubsite',
        subscribedSubsiteId: action.data.subscribedSubsiteId,
      };
  }

  return null;
}
